import React from 'react';
import { Row } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { safeExtractFromObject } from '../../helpers/helpers';

import LiveFeedCard from './LiveFeedCard';

import colors from '../../constants/Colors';

export default function LiveFeedTeamCard({
  team = {},
  onClick,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  const {
    name,
    members = [],
  } = team;
  const memberText = `${members.length} Member${members.length === 1 ? '' : 's'}`;

  return (
    <LiveFeedCard style={{ maxWidth: 175, padding: 15, }} onClick={onClick}>
      <Row style={{
        width: '100%',
        fontFamily:'roboto-bold',
      }} justify='start'>
        {name}
      </Row>
      <Row style={{
        width: '100%',
        fontFamily:'raleway-semibold',
        color: hasRedesign ? colors.REDESIGN_PRIMARY : colors.ONTRACCR_DARK_YELLOW,
        pointerEvents:'none',
        fontSize:12
      }} justify='start'>
        {memberText}
      </Row>
    </LiveFeedCard>
  );
}

LiveFeedTeamCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  team: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};
